import {useCustomerData} from './customer.hooks';
import {
  mapAuthenticationMethodToAuthMedium,
  mapCustomerGenderToUserGender,
} from './customer.mappers';

export const useCustomer = () => useCustomerData().data?.customer;

export const useCustomerTrackingData = () =>
  useCustomerData().data?.trackingData;

export const useCustomerIsVip = () => {
  return useCustomerTrackingData()?.isVip ?? false;
};

export const useCustomerBiData = () => {
  const trackingData = useCustomerTrackingData();
  if (trackingData?.isVip) {
    return {
      isVIP: trackingData.isVip,
      lifeSpan: trackingData.lifeSpan,
      pc180Score: trackingData.pc180Score,
      sizes: trackingData.sizes.flatMap(size => size.sizeIds),
    };
  }

  return {
    isVIP: false,
    lifeSpan: 0,
    pc180Score: 0,
    sizes: [],
  };
};

export const useCustomerLikedBrandIds = () => {
  return useCustomerTrackingData()?.brands.liked;
};

export const useCustomerId = (): number | null => {
  return useCustomer()?.id ?? null;
};

export const useUserEmail = () => useCustomer()?.email;

export const useUserFirstName = () => {
  return useCustomer()?.firstName?.trim() || undefined;
};

export const useUserGender = () => {
  const customer = useCustomer();
  return customer
    ? mapCustomerGenderToUserGender(customer.customerGender)
    : undefined;
};

export const useUserLoginType = () => {
  const customer = useCustomer();
  return customer
    ? mapAuthenticationMethodToAuthMedium(customer.authenticationMethod.type)
    : undefined;
};
